import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { LayoutGrid, LayoutList, Search } from "lucide-react";
import { useCallback } from "react";

type SectionProps = {
  title: string;
  searchTerm: string;
  setSearchTerm: (val: string) => void;
  children: React.ReactNode;
  gridToggle: any;
};
export const Section = ({
  title,
  searchTerm,
  setSearchTerm,
  children,
  gridToggle,
}: SectionProps) => {
  const toggleGrid = useCallback(() => {
    gridToggle?.setIsGrid(!gridToggle?.isGrid);
  }, [gridToggle]);

  return (
    <section className="flex-1 px-4 py-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-primary">{title}</h2>
        <div className="flex items-center gap-2">
          {gridToggle?.isGrid ? (
            <LayoutGrid className="w-5 h-5 text-primary" />
          ) : (
            <LayoutList className="w-5 h-5 text-primary" />
          )}
          <Switch checked={gridToggle?.isGrid} onCheckedChange={toggleGrid} />
        </div>
      </div>
      <div className="relative mb-6 max-w-md">
        <Input
          type="text"
          placeholder="Rechercher des titres..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="pl-10"
        />
        <Search className="absolute left-3 top-2.5 h-5 w-5 text-muted-foreground" />
      </div>
      {children}
    </section>
  );
};